import React from "react";
import { RelatedArticlesProps } from "@/types/modules/post/contentComponents";
import { RelatedPostItemLoader } from "@/components/modules/Post/ContentComponents/RelatedPostItemLoader";

export const RelatedArticles: React.FC<RelatedArticlesProps> = ({ title, articles }) => {
  return (
    <div className="mx-6 mb-6 max-w-[600px] pb-2 md:mx-auto">
      <h2 className="tracking-wider mt-6 border-b-2 border-orange pb-1 font-condensed text-lg font-light uppercase text-dark dark:text-white">
        {title}
      </h2>
      {articles.map((a) => (
        <RelatedPostItemLoader postId={a} key={a} isRelatedInArticle />
      ))}
    </div>
  );
};
